export default __webpack_public_path__ + "static/media/spokenWhoNeeds.ff6fdf9e.svg";